import { render, staticRenderFns } from "./AcceptedRejectedNormsModal.vue?vue&type=template&id=34eb4ba7&scoped=true"
import script from "./AcceptedRejectedNormsModal.vue?vue&type=script&lang=js"
export * from "./AcceptedRejectedNormsModal.vue?vue&type=script&lang=js"
import style0 from "./AcceptedRejectedNormsModal.vue?vue&type=style&index=0&id=34eb4ba7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34eb4ba7",
  null
  
)

export default component.exports